import { c as _c } from "react/compiler-runtime";
import { Box, Checkbox, Heading, HStack, VStack, Presence } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { ScoSignupRequest } from '@src/graphql-types';
export const SignupRequestPreviewTasks = props => {
  const $ = _c(12);
  const {
    getBreakpointValue,
    isMobile
  } = useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["Do this thing first", "Do this thing second", "Do this thing third", "Do this thing fourth", "Do this thing fifth", "Do this thing sixth"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const taskTitles = t0;
  let t1;
  if ($[1] !== getBreakpointValue) {
    t1 = getBreakpointValue([3, 3, 4]);
    $[1] = getBreakpointValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== getBreakpointValue) {
    t2 = getBreakpointValue([4, 4, 6, 6, 6]);
    $[3] = getBreakpointValue;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = isMobile ? "sm" : "md";
  let t4;
  if ($[5] !== t3) {
    t4 = <Heading size={t3} textAlign="center">Here's how we'll get this done!</Heading>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <VStack align="stretch" gap={2} justify="center" width="full">{taskTitles.map(_temp)}</VStack>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t4) {
    t6 = <VStack align="center" background="blackAlpha.500" borderRadius="xl" gap={t1} justify="center" padding={t2} width="full">{t4}{t5}</VStack>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
const TaskCard = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Checkbox.HiddenInput />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Checkbox.Root size="lg">{t0}<Checkbox.Control><Checkbox.Indicator /></Checkbox.Control></Checkbox.Root>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.taskTitle) {
    t2 = <Box background="PurpleSlate" borderRadius="lg" boxShadow="lg" width="full"><HStack padding={4}>{t1}<Heading flexGrow={1} fontSize="md">{props.taskTitle}</Heading></HStack></Box>;
    $[2] = props.taskTitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(taskTitle, index) {
  return <Box key={index}><Presence animationDuration="moderate" present={true} style={{
      animationDelay: `${index / 10}s`
    }} animationName={{
      _open: "slide-from-bottom, fade-in",
      _closed: "slide-to-bottom, fade-out"
    }}><TaskCard taskTitle={taskTitle} /></Presence></Box>;
}